import { Chip as DesignSystemChip } from "@octopusdeploy/design-system-components";
import * as React from "react";
import type { CommonChipProps } from "./types";
interface ChipProps extends CommonChipProps {
    onClick?: (event: object) => void;
    backgroundColorOnHover?: string;
    children?: React.ReactNode;
}
export const Chip: React.FC<ChipProps> = (props) => {
    const tooltipContent = props.noTooltip ? undefined : (props.description ?? props.children);
    return (<DesignSystemChip backgroundColor={props.backgroundColor} labelColor={props.labelColor} noMargin={props.noMargin} markAsRemoved={props.markAsRemoved} borderColor={props.borderColor} backgroundColorOnHover={props.backgroundColorOnHover} fullWidth={props.fullWidth} icon={props.icon} label={props.children} tooltipContent={tooltipContent} onClick={props.onClick} tabIndex={props.tabIndex} variant={props.variant} accessibilityRole={props.accessibilityRole} opacity={props.opacity}/>);
};
Chip.displayName = "Chip"
export default Chip;
